<template>
  <div class="q-mt-md service-agree-form">
    <p class="q-mb-xs privacy-text">
      以下利用規約・プライバシーポリシーをお読み頂き、同意の上ご利用ください。
    </p>
    <q-list dense class="service-agree-form-checkbox-area">
      <q-item>
        <q-item-section side class="q-pr-none">
          <q-checkbox v-model="isAgreeChecked.terms" color="primary" disable />
        </q-item-section>
        <q-btn dense flat color="primary" label="利用規約" @click="isDisplayDialog.terms = true" />
        <div class="q-my-auto">に同意する</div>
      </q-item>
      <q-item>
        <q-item-section side class="q-pr-none">
          <q-checkbox v-model="isAgreeChecked.policy" color="primary" disable />
        </q-item-section>
        <q-btn
          dense
          flat
          color="primary"
          label="プライバシーポリシー"
          @click="isDisplayDialog.policy = true"
        />
        <div class="q-my-auto">に同意する</div>
      </q-item>
    </q-list>
    <ServiceTermDialog :is-disp-dialog="isDisplayDialog.terms" @close-dialog="setTermCheck" />
    <PrivacyPolicyDialog :is-disp-dialog="isDisplayDialog.policy" @close-dialog="setPrivacyCheck" />
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import ServiceTermDialog from '../dialogs/ServiceTermDialog.vue';
import PrivacyPolicyDialog from '../dialogs/PrivacyPolicyDialog.vue';

interface Props {
  isAgreeChecked: {
    terms: boolean;
    policy: boolean;
  };
}

const props = defineProps<Props>();
const emit = defineEmits(['terms', 'policy']);

// チェック状態
const isAgreeChecked = reactive(props.isAgreeChecked);

// ダイアログ表示フラグ
const isDisplayDialog = reactive({
  terms: false,
  policy: false,
});

/**
 * 利用規約に同意したチェック状態を設定
 * @param {boolean} event チェック状態
 */
const setTermCheck = (event: boolean) => {
  // チェック状態に設定
  isAgreeChecked.terms = event;
  // ダイアログ非表示
  isDisplayDialog.terms = !event;
  emit('terms', true);
};

/**
 * プライバシーポリシーに同意したチェック状態を設定
 * @param {boolean} event チェック状態
 */
const setPrivacyCheck = (event: boolean) => {
  // チェック状態に設定
  isAgreeChecked.policy = event;
  // ダイアログ非表示
  isDisplayDialog.policy = !event;
  emit('policy', true);
};
</script>

<style scoped>
.service-agree-form .service-agree-form-checkbox-area {
  border: 2px solid var(--q-negative);
  padding: 4px 20px;
}
.service-agree-form .privacy-text {
  font-size: 0.8rem;
  line-height: 0, 8rem;
  color: var(--q-plainBlack);
  letter-spacing: 2px;
}
</style>
<style>
.service-agree-form .service-agree-form-checkbox-area button .q-btn__content span {
  padding-top: 1px;
}
</style>
